import { IconInfoCircle, IconCircleCheck, IconCircleX } from "@tabler/icons-react";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";
import moment from "moment";

export default function AccountDetailsCard({ details }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconInfoCircle size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Account Details</div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div
          className={`${styles.infoGrid} ${styles.infoGridSingle}`}
          style={{ gap: 14 }}
        >
          <div className={styles.infoField}>
            <div className={styles.infoLabel}>Member Since</div>
            <div className={styles.infoValue}>
              {moment(details?.createdAt).format("MMMM DD, YYYY")}
            </div>
          </div>
          <div className={styles.infoField}>
            <div className={styles.infoLabel}>Last Login</div>
            <div className={styles.infoValue}>
              {moment(details?.lastLogin).format("MMMM DD, YYYY")}
            </div>
          </div>
          <div className={styles.infoField}>
            <div className={styles.infoLabel}>Account Status</div>
            <div className={styles.infoValue}>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                  color: details?.profileVerified ? "#10b981" : "#ef4444",
                  fontWeight: 600,
                }}
              >
                {details?.profileVerified ? (
                  <IconCircleCheck size={15} />
                ) : (
                  <IconCircleX size={15} />
                )}{" "}
                {details?.profileVerified ? "Active" : "Not Verified"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
